require('./brokerHireInvestmentFundHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ContentBox } = require('commonsComponents/contentBox');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');
// @ helpers
const { formatAmount, formatAmountObject, getPlainAmountObject, formatPercentage } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
    BROKER_FUNDS_INDEX_VARIATION_DECIMALS,
    BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS,
    BROKER_FUNDS_PARTICIPATIONS_DECIMALS
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const language = getLanguage();

class BrokerHireInvestmentFundHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getParticipacionesLabel(immInvestmentFunds) {
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);

        if (isSubscription) {
            const holdingValue = immInvestmentFunds.get('holding');
            const holdingNumber = holdingValue.get('numberOfHoldings');
            const plainAmountObject = getPlainAmountObject(holdingValue);

            return (
                <span className="broker-hire-investment-header__holding-container-text">
                    <FormattedText value={'brokerHireInvestment-holdingNumberLabel'} />
                    {formatAmount(holdingNumber, undefined, BROKER_FUNDS_PARTICIPATIONS_DECIMALS)}
                    <FormattedText value={'brokerHireInvestment-holdingAmountLabel'} />
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </span>
            );
        } else {
            return '';
        }
    }

    render() {
        const { immBrokerProductAdvancedSearch } = this.props;
        const immInvestmentFunds = this.props.immInvestmentFunds.getIn([
            'steps',
            0,
            'investmentFunds'
        ]);
        const name = immInvestmentFunds.get('name');
        const isin = immInvestmentFunds.get('isin');
        const rentability = formatPercentage(immInvestmentFunds.get('rentability'));
        const variationPoints = immInvestmentFunds.get('variationPoints', '').toString();
        const variationPercent = immInvestmentFunds.get('variationPercent', '').toString();
        const netAssetDayEndDate = immInvestmentFunds.getIn(['netAssetValue', 'dayEndDate']);
        const formattedEndDate = DateHelper.buildFormattedDate(
            netAssetDayEndDate,
            formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)
        );
        const holdingValue = this.props.immInvestmentFunds.get('holding');
        const netAssetDayEndValue = {
            amount: immInvestmentFunds.getIn(['netAssetValue', 'amount']),
            currency: immInvestmentFunds.getIn(['netAssetValue', 'currency']),
            decimalsLength: BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS
        };

        if (!netAssetDayEndDate || !holdingValue) {
            return null;
        }

        const plainAmountObject = getPlainAmountObject(netAssetDayEndValue);
        const currencySymbol = formatAmountObject(plainAmountObject, true).currencySymbol;
        const performanceYTDLabel = `${formatText('brokerHireInvestment-performanceYTD')}: `;
        const performanceLastYearLabel = `${formatText('brokerHireInvestment-lastYearProfitability')} ${DateHelper.getFullYear(DateHelper.todayDate()) - 1}: `;
        const immInstrumentList = immBrokerProductAdvancedSearch.getIn(['results','funds','instrumentsList']);
        let performanceLastYear;
        if (immInstrumentList) {
            const performanceLastYearValue = immInstrumentList.getIn([ 0, 'lastYearReturnValue']);
            performanceLastYear = performanceLastYearValue ?
            formatAmount(Number(performanceLastYearValue).toFixed(2)) + " %" :
            '-';
        }
        else {
            performanceLastYear = '-';
        }

        return (
            <ContentBox id="brokerStocksLikeHeader" customClassName="broker-hire-investment-header broker-hire-investment-header--funds">
                <div className="broker-hire-investment-header__header row">
                    <div className="col-lg-8">
                        <div className="broker-hire-investment-header__company-header">
                            <h2 className="broker-hire-investment-header__company-name">
                                {name}
                            </h2>
                        </div>
                        <span className="broker-hire-investment-header__isin">
                            <FormattedText value={'brokerHireInvestment-isin'} />: {isin}
                        </span>
                    </div>

                    <div className="col-lg-4">
                        <div className="broker-hire-investment-header__quote-box">
                            <div className="broker-hire-investment-header__quote">
                                {performanceYTDLabel}
                                <span className="broker-hire-investment-header__product-value">
                                    {rentability}
                                </span>
                            </div>
                            <div className="broker-hire-investment-header__quote-last-year">
                                {performanceLastYearLabel}
                                <span className="broker-hire-investment-header__product-value-last-year">
                                    {performanceLastYear}
                                </span>
                            </div>
                            <div className="broker-hire-investment-header__liquidating-value">
                                <FormattedText value={'brokerHireInvestment-netAssetDayEndDate'} />
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            </div>

                            <div className="broker-hire-investment-header__index-box">
                                <span className="broker-hire-investment-header__index-value">
                                    <StockExchangeIndexVariation
                                        variationPts={formatAmount(variationPoints, undefined, BROKER_FUNDS_INDEX_VARIATION_DECIMALS)}
                                        variationPerc={formatAmount(variationPercent)}
                                        currencySymbol={currencySymbol}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="broker-hire-investment-header__wallet-last-price-section row">
                    <div className="broker-hire-investment-header__holding-container col-lg-6">
                        {this.getParticipacionesLabel(this.props.immInvestmentFunds)}
                    </div>
                    <div className="broker-hire-investment-header__last-price-container col-lg-6">
                        <span className="broker-hire-investment-header__last-price-date">
                            <span className="broker-hire-investment-header__last-value-date">
                                ({formattedEndDate})
                            </span>
                        </span>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

BrokerHireInvestmentFundHeader.propTypes = {
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    modifier: PropTypes.string
};

module.exports = BrokerHireInvestmentFundHeader;
